"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var translations = {
    disableConfirm: {
        en: "Are you sure you want to disable?",
        es: "¿Está seguro que lo quiere Deshabilitar?",
    },
    enableConfirm: {
        en: "Are you sure you want to enable?",
        es: "¿Está seguro que lo quiere habilitar?",
    },
    stopEmailConfirm: {
        en: "Are you sure you want to stop receiving email alerts?",
        es: "¿Está seguro de que desea dejar de recibir alertas por correo electrónico?",
    },
    default: {
        en: "Default profile",
        es: "Perfil principal",
    },
    duplicate: {
        en: "Duplicate profile",
        es: "Duplicar principal",
    },
    edit: {
        en: "Edit",
        es: "Editar",
    },
    editDevices: {
        en: "Edit  ({amountDevices})",
        es: "Editar ({amountDevices})",
    },
    add: {
        en: "Add",
        es: "Agregar",
    },
    addLineOfInterest: {
        en: "Add line of interest",
        es: "Agregar linea de interés",
    },
    searchPlaceholder: {
        en: "Search",
        es: "Buscar",
    },
    unfollow: {
        en: "Leave shared group",
        es: "Salir del grupo compartido",
    },
    uploadFile: {
        en: "Upload file",
        es: "Subir archivo",
    },
    undoneAction: {
        en: 'This action cannot be undone.',
        es: 'Esta acción no se puede deshacer.'
    },
    dragAndDrop: {
        en: 'Drag and drop file or click here to upload the file',
        es: 'Arrastre y suelte el archivo o haga click aquí para cargarlo'
    },
    supportedFormats: {
        en: 'Supported formats',
        es: 'Formatos soportados'
    },
    share: {
        en: "Share",
        es: "Compartir",
    },
    shareDevicesAmount: {
        en: "Share ({amountDevices})",
        es: "Compartir ({amountDevices})",
    },
    stopSharing: {
        en: "Stop Sharing",
        es: "Dejar de Compartir",
    },
    sharingsuccess: {
        en: "The selected {amountOfDevices, plural, one {unit has been } other {units have been }} shared successfully with {amountOfClients, plural, one {# client } other {#  clients}}.",
        es: "{amountOfDevices, plural, one {La unidad seleccionada } other {Las unidades seleccionadas }} {amountOfDevices, plural, one {ha sido}other {han sido}} {amountOfDevices, plural, one { compartida} other {compartidas}} exitosamente con {amountOfClients, plural, one {# cliente } other {#  clientes}}.",
    },
    stopsharingsuccess: {
        en: "Unit {device} it is not longer shared with {client, plural, one {# client} other {# clients}}.",
        es: "Se dejo de compartir la unidad {device} con {client, plural, one {# cliente} other {# clientes}} exitosamente.",
    },
    stopSharingConfirm: {
        en: "Are you sure you want to stop sharing",
        es: "¿Está seguro que quiere dejar de compartir?",
    },
    disable: {
        en: "Disable",
        es: "Deshabilitar",
    },
    enable: {
        en: "Enable",
        es: "Habilitar",
    },
    delete: {
        en: "Delete",
        es: "Eliminar",
    },
    deleteAmount: {
        en: "Delete ({amountDevices})",
        es: "Eliminar ({amountDevices})",
    },
    deleteConfirm: {
        en: "Are you sure you want to delete?",
        es: "¿Está seguro que quiere eliminar?",
    },
    unfollowConfirm: {
        en: "If you proceed, you'll lose access to the shared units from this group. Continue?",
        es: "Si continúas, perderás acceso a los dispositivos compartidos de este grupo. ¿Deseas continuar?",
    },
    deleteConfirmFeedback: {
        en: "Are you sure you want to delete {taskTitle}?",
        es: "¿Está seguro que quiere eliminar {taskTitle}?",
    },
    deleteSession: {
        en: "Invalidate",
        es: "Anular",
    },
    deleteSessionConfirm: {
        en: "Are you sure you want to Invalidate all sessions?",
        es: "¿Esta seguro que quiere anular las sesiones",
    },
    deleteAll: {
        en: "Are you sure you want to delete all",
        es: "¿Está seguro que quiere eliminar todo?",
    },
    deleteAllConfirm: {
        en: "Are you sure you want to delete all?",
        es: "¿Está seguro que quiere eliminarlos a todos?",
    },
    role: {
        en: "Roles",
        es: "Roles",
    },
    limitReached: {
        en: "Limit reached",
        es: "Límite alcanzado",
    },
    impersonate: {
        en: "Impersonate",
        es: "Personificar",
    },
    revertImpersonate: {
        en: "Revert impersonate",
        es: "Revertir personificar",
    },
    restart: {
        en: "Restart",
        es: "Reiniciar",
    },
    eventEnable: {
        en: "Event {name} was enable",
        es: "El evento {name} ha sido habilitado",
    },
    eventDisable: {
        en: "Event {name} was disable",
        es: "El evento {name}  ha sido deshabilitado",
    },
    addTank: {
        en: "Add tank",
        es: "Agregar tanque",
    },
    deteleTankConfig: {
        en: "Are you sure to delete this configuration?",
        es: "¿Está seguro que quiere eliminar esta configuración?",
    },
    deteleThermometerConfig: {
        en: "Are you sure to delete this configuration?",
        es: "¿Está seguro que quiere eliminar esta configuración?",
    },
    deleteSelectedTasks: {
        en: "Do you want to delete the {taskCount, plural, =0 {selected task} one {selected task} other {# selected tasks}}?",
        es: "¿Desea eliminar {taskCount, plural, =0 {la tarea seleccionada} one {la tarea seleccionada} other {las # tareas seleccionadas}}?",
    },
    deleteAllSelectedTasks: {
        en: "Do you want to delete the selected tasks?",
        es: "¿Desea eliminar las tareas seleccionadas?",
    },
    cae: {
        en: "CAE 911 ({amountDevices})",
        es: "CAE 911 ({amountDevices})",
    },
    exportDevices: {
        en: "Export ({amountDevices})",
        es: "Exportar ({amountDevices})",
    },
    copyToClipboard: {
        en: "Copy to clipboard",
        es: "Copiar al portapapeles",
    },
    apyKeycopyToClipboard: {
        en: "Api key was copied to clipboard",
        es: "El api key fue copiado al portapapeles",
    },
    invalidApiKey: {
        en: "Api key is no longer validate, refresh api key to get a new one.",
        es: "El api key ya no es valida, refresque el api key para conseguir una nueva",
    },
    apyKeyRefresh: {
        en: "Refresh Api key",
        es: "Refrescar Api key",
    },
    deleteTagsAction: {
        en: "Delete tags",
        es: "Eliminar etiquetas",
    },
    sendCommandConfirm: {
        en: "Are you sure you want to send this command?",
        es: "¿Está seguro que quiere enviar este comando?",
    },
    shareVia: {
        en: "Share via...",
        es: "Compartir vía...",
    },
    alreadyAdded: {
        en: "{name} was already added",
        es: "{name} ya estaba agregado",
    },
    accept: {
        en: "Accept",
        es: "Aceptar",
    },
    dueDateAlertMessage: {
        en: "Due date alert",
        es: "Alerta de fecha de vencimiento",
    },
    dueDateAlertDescription: {
        en: "Your account is reaching its expiration date. Please make the corresponding payment or contact administration for more information and avoid expiration of your account. Due date: {date}.",
        es: "Su cuenta está llegando a su fecha de vencimiento. Por favor realice el pago correspondiente o comuníquese con administración para obtener más información y evitar el vencimiento de su cuenta. Fecha de vencimiento: {date}.",
    },
    cancelConfirm: {
        en: "Are you sure you want to cancel?",
        es: "¿Está seguro que quiere cancelar?",
    },
    viewLogs: {
        en: "View Logs",
        es: "Ver los registros",
    },
    selectAllUnits: {
        en: "Select all units",
        es: "Seleccionar todas las unidades",
    },
    sendCommandAmount: {
        en: "Send command ({amount})",
        es: "Enviar commando ({amount})",
    },
    addDriver: {
        en: "Add Driver",
        es: "Agregar Conductor",
    },
    finish: {
        en: "Finish",
        es: "Terminar",
    },
    scheduleCommand: {
        en: "Schedule command",
        es: "Programar comando",
    },
    selectDays: {
        en: "Select one day or more to save.",
        es: "Seleccione un día o mas para salvar.",
    },
    addComment: {
        en: "Add Comment",
        es: "Agregar Comentario",
    },
    more: {
        en: "More",
        es: "Más",
    },
    selectValue: {
        en: "Select a value",
        es: "Seleccione un valor",
    },
    selectAllValues: {
        en: "Select all",
        es: "Seleccionar todos",
    },
    deleteTrackingHistory: {
        en: "Delete tracking history",
        es: "Eliminar historial de rastreo",
    },
    chooseAnOption: {
        en: "Choose an option!",
        es: "Escoge una opción!",
    },
    removeAtPeriodEnd: {
        en: "At Period End",
        es: "Al final del período",
    },
    removeNow: {
        en: "Remove now",
        es: "Remover ahora",
    },
    unsubscribe: {
        en: "Unsubscribe",
        es: "Cancelar Suscripción",
    },
    cancelTrial: {
        en: "Cancel Trial",
        es: "Cancelar Periodo de Prueba",
    },
    closeAccount: {
        en: "Are you sure you want to close the account?",
        es: "¿Está seguro que quiere cerrar la cuenta?",
    },
    viewMore: {
        en: "View More",
        es: "Ver Más",
    },
    clearSelection: {
        en: "Clear selection",
        es: "Anular selección",
    },
    openSettings: {
        en: "Open Settings",
        es: "Abrir Configuración",
    },
    closeWithoutSaving: {
        en: "Close without saving changes?",
        es: "¿Cerrar sin guardar cambios?"
    },
    continueWithoutSaving: {
        en: 'Continue without saving changes?',
        es: '¿Continuar sin guardar los cambios?'
    },
    continueEdit: {
        en: 'Continue editing',
        es: 'Continuar editando',
    },
    discardClose: {
        en: 'Discard changes and close',
        es: 'Descartar cambios y cerrar',
    },
    discardContinue: {
        en: 'Discard changes & continue',
        es: 'Descartar cambios y continuar',
    },
    sendVerificationCode: {
        en: "Send verification code",
        es: "Enviar código de verificación",
    },
    unsaved: {
        en: 'Unsaved Changes',
        es: 'Cambios sin guardar',
    },
    unsavedLeave: {
        en: 'You have unsaved changes. Are you sure you want to leave?',
        es: 'Tiene cambios sin guardar. Está seguro que desea salir?'
    },
    leaveGroup: {
        en: "Leave group",
        es: "Salir del grupo",
    },
    enablePhoneNumber: {
        en: 'Enable phone number',
        es: 'Habilitar número de teléfono'
    },
    enablePostedSpeedLimit: {
        en: "Enable posted speed limit",
        es: "Habilitar limite de velocidad",
    },
    disablePostedSpeedLimit: {
        en: "Disable posted speed limit",
        es: "Deshabilitar limite de velocidad",
    },
    triggerSmsNotification: {
        en: "Trigger SMS Notification",
        es: "Enviar notificación por SMS",
    },
    triggerEmailNotification: {
        en: "Trigger Email Notification",
        es: "Enviar notificación por correo",
    },
};
exports.default = translations;
